



































import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'
import { defaultSystemCode, SystemCode } from '@/api'

@Component
export default class AtomSystemParameterSelect extends ComponentVue {
  @Ref()
  atomSystemParameterSelect!: any

  @Prop({ type: String })
  label!: string

  @Prop({ type: Array })
  items!: SystemCode[]

  @Prop({ type: Object })
  value!: SystemCode

  @Prop({ type: Boolean, default: false })
  displayName!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({ type: Number, default: 500 })
  emitIntervalMs!: number

  @Prop({ type: Boolean, default: false })
  blank!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  isEmit: boolean = true

  get useItems(): SystemCode[] {
    return this.blank ? [defaultSystemCode(), ...this.items] : this.items
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get style(): object {
    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get isError(): boolean {
    return this.error || this.errorMessage !== ''
  }

  @Emit('input')
  onChange() {}

  onKeydownEnter() {
    if (this.isEmit) {
      this.$emit('keydown:enter')
      this.isEmit = false

      setTimeout(() => (this.isEmit = true), this.emitIntervalMs)
    }
  }

  itemText(item: SystemCode) {
    return (
      item.code +
      (item.code ? '：' : '') +
      (this.displayName ? item.name : item.shortName)
    )
  }

  itemValue(item: SystemCode) {
    return item
  }
}
